<template id="map-template">
  <div class="homeview-taskcenter-data">
    <div class="header">
      <span class="header-title">任务中心</span>
      <div class="arrow-pic"></div>
      <div class="icon-spread"></div>
    </div>
    <div class="table-chart">
      <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
        <el-table-column prop="ExecWay" label="任务类型" :formatter="getExecWayShow"></el-table-column>
        <el-table-column prop="CreateTime" label="任务时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="TaskTitle" label="任务类容">
          <template slot-scope="scope">
            <el-popover placement="top-start" title="任务类容" width="250" trigger="hover">
              <div>{{scope.row.TaskTiltle}}</div>
              <span
                slot="reference"
              >{{ scope.row.TaskTiltle && scope.row.TaskTiltle.length>3?scope.row.TaskTiltle.substr(0,3)+'...':scope.row.TaskTiltle }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="TaskStatus" label="处理状态" :formatter="formatStatus"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import Constant from "../config/constant";

export default {
  name: "HomeViewTaskCenter",
  componentName: "HomeViewTaskCenter",
  components: {},
  props: {},
  data() {
    return {
      tableData: [],
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      let searchInfo = {
        ExecutId: "",
        Validity: 1,
        PageSize: 10,
        PageIndex: 0,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.ExecutTaskApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("MM/dd hh:mm");
    },
    formatStatus(row, column) {
      // 获取单元格数据
      let data = row[column.property];

      var status = "";
      if (
        data == Constant.TaskStatus.Todo.desc ||
        data == Constant.TaskStatus.Todo.code ||
        data == Constant.TaskStatus.Processing.desc ||
        data == Constant.TaskStatus.Processing.code
      ) {
        status = "执行中";
      } else if (
        data == Constant.TaskStatus.Done.desc ||
        data == Constant.TaskStatus.Done.code ||
        data == Constant.TaskStatus.Closed.desc ||
        data == Constant.TaskStatus.Closed.code
      ) {
        status = "已完成";
      } else {
        status = "启动失败";
      }
      return status;
    },
    getExecWayShow(row, column) {
      let data = row[column.property];
      if (data == "1") return "自动";
      else return "人工";
    },
  },
   
};
</script>